import { css } from 'styled-components';

export const ContentStyle = css(({ theme }) => {
  return css`
    height: 100%;
    width: 100%;

    > .dynamic-popup-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: auto 40px;
      height: 100%;

      .dynamic-popup-title {
        max-width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 21px;
        line-height: 32px;
        padding: 0 12px;
      }

      .dynamic-popup-image {
        width: 140px;
        height: 140px;
        margin-bottom: 40px;
      }

      .dynamic-popup-footer {
        display: flex;
        flex-direction: column;
        margin-top: 60px;
        align-items: center;
      }

      @media screen and ${theme.device.max.mobileXL} {
        margin: 0px;
      }
    }
  `;
});
